<template>
  <div class="help-center">
    <div class="help-center__header">
      <div class="help-center__breadcrumb" @click="navigateToHome">锦汇卡回收 ></div>
      <div class="help-center__title">帮助中心</div>
    </div>
    <div class="help-center__content">
      <!-- 左侧菜单 -->
      <div class="help-center__sidebar">
        <div class="sidebar-item" v-for="menuItem in menuItems" :key="menuItem.id">
          <div class="sidebar-item__header" :class="{ 'sidebar-item__header--active': activeMenuId === menuItem.id }"
            @click="handleMenuItemClick(menuItem)">
            <img :src="getMenuItemIcon(menuItem)" alt="" class="sidebar-item__icon" />
            <span class="sidebar-item__title">{{ menuItem.title }}</span>
            <div class="sidebar-item__arrow" v-if="menuItem.child"
              :class="{ 'sidebar-item__arrow--rotated': menuItem.id === 4 && isSubmenuVisible }">
              <img src="../assets/image/gerenxiala.png" alt="" />
            </div>
          </div>

          <!-- 子菜单 -->
          <div class="sidebar-item__submenu" v-for="submenuItem in menuItem.child || []" :key="submenuItem.id"
            :class="{ 'sidebar-item__submenu--active': activeSubmenuId === submenuItem.id }"
            v-if="menuItem.id === 4 && isSubmenuVisible" @click="handleSubmenuItemClick(submenuItem)">
            {{ submenuItem.title }}
          </div>
        </div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="help-center__main">
        <div class="help-center__container">
          <h2 class="help-center__container-title">{{ currentTitle }}</h2>

          <!-- 动态组件 -->
          <component :is="currentComponent" v-if="!isArticleContent"></component>

          <!-- 文章内容 -->
          <div v-if="isArticleContent" v-html="formattedArticleContent" class="help-center__article"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import contact from "../components/base/help/contact.vue";
import trade from "../components/base/help/trade.vue";
import sellflow from "../components/base/help/sellflow.vue";
import business from "../components/base/help/business.vue";
import huishou from "../components/base/help/101.vue";
import frequestion from "../components/base/help/frequestion.vue";
import notice from "../components/base/help/notice.vue";
import certificate from "../components/base/help/certificate.vue";

// 组件映射表
const COMPONENT_MAP = {
  0: 'contact',
  1: 'trade',
  2: 'sellflow',
  6: 'business',
  7: 'notice',
  8: 'frequestion',
  9: 'huishou',
  10: 'certificate'
};

// 文章ID映射表
const ARTICLE_ID_MAP = {
  4.1: 4,  // 隐私政策
  4.2: 1,  // 注册协议
  4.3: 8,  // 免责声明
  4.4: 9   // 转让协议
};

export default {
  name: 'HelpCenter',
  components: {
    contact,
    trade,
    sellflow,
    business,
    huishou,
    frequestion,
    notice,
    certificate
  },
  data() {
    return {
      activeMenuId: 0,                // 当前选中的主菜单ID
      activeSubmenuId: 0,             // 当前选中的子菜单ID
      articleData: {},                // 文章详情
      currentTitle: "联系我们",        // 当前页面标题
      isSubmenuVisible: false,        // 子菜单是否可见

      // 菜单数据
      menuItems: [
        {
          id: 0,
          title: "联系我们",
          image: require("../assets/newImage/data_image0.png"),
          image1: require("../assets/newImage/data_image0_0.png"),
        },
        {
          id: 1,
          title: "交易方式",
          image: require("../assets/newImage/data_image1.png"),
          image1: require("../assets/newImage/data_image1_1.png"),
        },
        {
          id: 2,
          title: "卖卡流程",
          image: require("../assets/newImage/data_image2.png"),
          image1: require("../assets/newImage/data_image2_2.png"),
        },
        // {
        //   id: 3,
        //   title: "商户API",
        //   image: require("../assets/newImage/data_image3.png"),
        //   image1: require("../assets/newImage/data_image3.png"),
        // },
        {
          id: 4,
          title: "协议/声明",
          image: require("../assets/newImage/data_image4.png"),
          image1: require("../assets/newImage/data_image6.png"),
          child: [
            {
              id: 4.1,
              title: "隐私政策",
              parentId: 4,
            },
            {
              id: 4.2,
              title: "注册协议",
              parentId: 4,
            },
            {
              id: 4.3,
              title: "免责声明",
              parentId: 4,
            },
            {
              id: 4.4,
              title: "转让协议",
              parentId: 4,
            },
          ],
        },
        {
          id: 5,
          title: "卡券学堂",
          image: require("../assets/newImage/data_image5.png"),
          image1: require("../assets/newImage/data_image5.png"),
        },
        {
          id: 6,
          title: "商家合作",
          image: require("../assets/newImage/data_image6.1.png"),
          image1: require("../assets/newImage/data_image6_6.png"),
        },
        {
          id: 7,
          title: "网站公告",
          image: require("../assets/newImage/data_image7.png"),
          image1: require("../assets/newImage/data_image7_7.png"),
        },
        {
          id: 8,
          title: "常见问题",
          image: require("../assets/newImage/data_image8.png"),
          image1: require("../assets/newImage/data_image8_8.png"),
        },
        {
          id: 9,
          title: "回收说明",
          image: require("../assets/newImage/data_image9.png"),
          image1: require("../assets/newImage/data_image9_9.png"),
        },
        {
          id: 10,
          title: "平台资质",
          image: require("../assets/newImage/矩形@2.11x.png"),
          image1: require("../assets/newImage/矩形@2x (1).png"),
        },
      ],
    };
  },
  computed: {
    /**
     * 获取当前应该显示的组件名称
     */
    currentComponent() {
      return COMPONENT_MAP[this.activeMenuId] || null;
    },

    /**
     * 判断是否显示文章内容
     */
    isArticleContent() {
      return this.activeSubmenuId === 4.1 ||
        this.activeSubmenuId === 4.2 ||
        this.activeSubmenuId === 4.3 ||
        this.activeSubmenuId === 4.4;
    },

    /**
     * 获取格式化后的文章内容
     */
    formattedArticleContent() {
      return this.formatHtmlContent(this.articleData.content || '');
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      window.scrollTo(0, 0);
      this.handleStoreState();
    },

    /**
     * 处理从store中获取的状态
     */
    handleStoreState() {
      if (this.$store.state.menuIdX) {
        const menuIndex = this.$store.state.menuIdX;
        const menuItem = this.menuItems[menuIndex];

        if (menuItem) {
          this.handleMenuItemClick(menuItem);

          if (this.$store.state.leftChildIdX) {
            const submenuId = this.$store.state.leftChildIdX;
            const submenuItem = menuItem.child &&
              menuItem.child.find(item => item.id === submenuId);

            if (submenuItem) {
              this.handleSubmenuItemClick(submenuItem);
              this.isSubmenuVisible = true;
            }
          }
        }

        // 重置存储的菜单状态
        this.$store.commit('changedMenuId', 0);
        this.$store.commit('changedLeftChildId', 0);
      }
    },

    /**
     * 处理菜单项点击
     */
    handleMenuItemClick(menuItem) {
      window.scrollTo(0, 0);
      this.activeSubmenuId = 0;

      switch (menuItem.id) {
        case 3:
          // 商户API - 外部链接
          window.open("https://merchant.huishouka.com.cn", "_blank");
          break;
        case 5:
          // 卡券学堂 - 路由跳转
          this.$router.push({ path: "/Cardschool" });
          break;
        case 4:
          // 协议/声明 - 展开/折叠子菜单
          this.isSubmenuVisible = !this.isSubmenuVisible;
          break;
        default:
          // 普通菜单项
          this.activeMenuId = menuItem.id;
          this.currentTitle = menuItem.title;
          this.isSubmenuVisible = false;
          break;
      }
    },

    /**
     * 处理子菜单项点击
     */
    handleSubmenuItemClick(submenuItem) {
      console.log("submenuItem",submenuItem);
      this.activeSubmenuId = submenuItem.id;
      this.activeMenuId = submenuItem.parentId;
      this.currentTitle = submenuItem.title;
      window.scrollTo(0, 0);
      // 获取对应的文章内容
      const articleId = ARTICLE_ID_MAP[submenuItem.id];
      if (articleId) {
        this.fetchArticleDetail(articleId);
      }
    },

    /**
     * 获取文章详情
     */
    fetchArticleDetail(articleId) {
      http.get(`/article/details/${articleId}`)
        .then(response => {
          if (response.code === 200) {
            this.articleData = response.data || { content: "" };
          }
        })
        .catch(error => {
          console.error('获取文章详情失败', error);
        });
    },

    /**
     * 格式化HTML内容
     */
    formatHtmlContent(content) {
      if (!content) return '';

      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');

        // 设置所有元素的行高
        doc.querySelectorAll('*').forEach(el => {
          el.style.lineHeight = '1.5';
        });

        return doc.body.innerHTML;
      } catch (error) {
        console.error('格式化HTML内容失败', error);
        return content;
      }
    },

    /**
     * 获取菜单项图标
     */
    getMenuItemIcon(menuItem) {
      return this.activeMenuId === menuItem.id ? menuItem.image1 : menuItem.image;
    },

    /**
     * 导航到首页
     */
    navigateToHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style lang="scss" scoped>
.help-center {
  background-color: #ECF2FE;
  padding: 0 120px;
  margin-top: 95px;

  &__header {
    height: 44px;
    display: flex;
    align-items: center;
  }

  &__breadcrumb {
    color: #000000a6;
    font-size: 14px;
    font-weight: 500;
    margin-right: 5px;
    cursor: pointer;
  }

  &__title {
    font-size: 17px;
    color: #488eff;
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }

  &__sidebar {
    width: 280px;
    background-color: white;
    border-radius: 10px;
    padding: 10px 0;
    flex-shrink: 0;
  }

  &__main {
    margin-left: 20px;
    flex: 1;
    background-color: white;
    border-radius: 10px;
  }

  &__container {
    padding: 25px;
  }

  &__container-title {
    color: #000000e0;
    font-size: 24px;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 20px;
  }

  &__article {
    max-height: 90vh;
    overflow-y: auto;
    margin-top: 10px;
    line-height: 1.5;
  }
}

.sidebar-item {
  &__header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: rgba(72, 142, 255, 0.1);
    }

    &--active {
      background-color: #488eff;
      color: white;
    }
  }

  &__icon {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }

  &__title {
    font-size: 17px;
    margin-left: 10px;
  }

  &__arrow {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;
    width: 16px;
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      transition: transform 0.3s;
    }

    &--rotated img {
      transform: rotate(180deg);
    }
  }

  &__submenu {
    height: 56px;
    display: flex;
    align-items: center;
    padding-left: 74px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 17px;
    text-align: left;
    background-color: #f8f8f8;

    &:hover {
      background-color: rgba(72, 142, 255, 0.1);
    }

    &--active {
      background-color: rgba(72, 142, 255, 0.1);
      color: #488eff;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 24px;
        background-color: #488eff;
      }
    }
  }
}

// 右侧内容区域样式
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}

.yellow-view {
  margin-top: 10px;
  padding: 20px;
  background: #fff4db;
  border-radius: 8px;
  box-sizing: border-box;
  color: #a95300;
  margin-bottom: 16px;
  padding: 12px 14px 12px 24px;
}
</style>
